import request from '@/config';

enum Apis {
	CacheList = `/api/sysuser/getusercachelist`,
	CacheListByRole = `/api/sysuser/getusercachelistbyrole`
}

export const GetUserCacheApi = (): Promise<IResponse> => request.post({ url: Apis.CacheList, data: {} });


export const GetUserCacheByRoleApi = (role:string): Promise<IResponse> => request.post({ url: Apis.CacheListByRole, data: {"role":role}});